import type { HeroBannerCarouselItemWeb } from '@vista-digital/lumos-cms-client'
import type { FC } from 'react'
import type { CarouselConfig } from '../OccCarousel'
import { HeroBanner } from '../OmniaHeroCarousel/hero-banner'
import { useGetHeroBannerPageProps } from '../OmniaHeroCarousel/props'
import type { HeroCarouselPropsApi } from './heroCarousel.models'
import { mapHeroCarouselCmsPropsToLumos } from './utils/map-hero-carousel-cms-props-to-lumos'

interface HeroCarouselProps {
    slides: HeroCarouselPropsApi['HeroCarousel']
    carouselConfig: CarouselConfig
}

const HeroCarousel: FC<HeroCarouselProps> = props => {
    const carouselItems: HeroBannerCarouselItemWeb[] = mapHeroCarouselCmsPropsToLumos(props.slides)
    const { carouselConfig } = useGetHeroBannerPageProps('HeroBanner', carouselItems.length)
    return <HeroBanner carouselItems={carouselItems} carouselConfig={carouselConfig} />
}

export default HeroCarousel
